import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SingleCardComponent } from '../../layouts/single-card/single-card.component';
import { LoginFormComponent } from '../../shared/components/login-form/login-form.component';

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SingleCardComponent, LoginFormComponent],
})
export class LoginPageComponent {}
